import * as Yup from "yup";

import { costTypeItems, transactionTypeItems, userRoleItems } from "../enum";

// Phone Number
const phoneNumberRegex = /^09\d{9}$/;

export const isValidPhoneNumber = (phoneNumber) => {
  return phoneNumberRegex.test(phoneNumber);
};

// Email
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isValidEmail = (email) => {
  return emailRegex.test(email);
};

// Text
export const persianRegex = /^[\u0600-\u06FF\u200C\u200B\s]+$/;
export const englishRegex = /^[A-Za-z\s]+$/;

// Date
export const isDateBiggerThan = (firstDate, secondDate) => {
  if (secondDate) {
    const convertFirstDate = new Date(firstDate);
    const convertSecondDate = new Date(secondDate);

    return convertSecondDate.getTime() < convertFirstDate.getTime();
  } else {
    const dateNow = new Date();
    const convertFirstDate = new Date(firstDate);

    return dateNow.getTime() < convertFirstDate.getTime();
  }
};

//* Start Yup Validations

// Validation
const phoneNumber = Yup.string()
  .required("شماره موبایل الزامی است")
  .min(11, "شماره موبایل نمی تواند کمتر از 11 کاراکتر باشد")
  .max(11, "شماره موبایل نمی تواند بیشتر از 11 کاراکتر باشد")
  .matches(phoneNumberRegex, "شماره موبایل وارد شده معتبر نیست");
const password = Yup.string()
  .required("کلمه عبور الزامی است")
  .min(6, "کلمه عبور نمی تواند کمتر از 6 کاراکتر باشد")
  .max(255, "کلمه عبور نمی تواند بیشتر از 255 کاراکتر باشد");
const newPassword = Yup.string()
  .required("کلمه عبور جدید الزامی است")
  .min(6, "کلمه عبور جدید نمی تواند کمتر از 6 کاراکتر باشد")
  .max(255, "کلمه عبور جدید نمی تواند بیشتر از 255 کاراکتر باشد");
const confirmPassword = Yup.string()
  .required("تکرار کلمه عبور الزامی است")
  .oneOf(
    [Yup.ref("password"), null],
    "کلمه عبور و تکرار کلمه عبور یکسان نیستند"
  );
const firstName = Yup.string()
  .required("نام الزامی است")
  .max(255, "نام نمی تواند بیشتر از 255 کاراکتر باشد")
  .matches(persianRegex, "نام باید حروف فارسی باشد")
  .trim();
const lastName = Yup.string()
  .required("نام خانوادگی الزامی است")
  .max(255, "نام خانوادگی نمی تواند بیشتر از 255 کاراکتر باشد")
  .matches(persianRegex, "نام خانوادگی باید حروف فارسی باشد")
  .trim();
const firstNameLatin = Yup.string()
  .required("نام لاتین الزامی می باشد")
  .max(255, "نام لاتین نمی تواند بیشتر از 255 کاراکتر باشد")
  .matches(englishRegex, "نام لاتین باید حروف لاتین باشد");
const lastNameLatin = Yup.string()
  .required("نام خانوادگی لاتین الزامی می باشد")
  .max(255, "نام خانوادگی لاتین نمی تواند بیشتر از 255 کاراکتر باشد")
  .matches(englishRegex, "نام خانوادگی لاتین باید حروف لاتین باشد");
const birthDate = Yup.string().nullable();
const avatar = Yup.string().max(
  255,
  "نام فایل تصویر پروفایل نمی تواند بیشتر از 255 کاراکتر باشد"
);
const role = Yup.string()
  .required("نقش الزامی است")
  .oneOf(userRoleItems, "نقش مجاز نیست");
const isVIP = Yup.bool().required("نوع کاربر الزامی است");
const permissions = Yup.string()
  .required("سطح دسترسی الزامی است")
  .min(6, "سطح دسترسی نمی تواند کمتر از 6 کاراکتر باشد")
  .max(6, "سطح دسترسی نمی تواند بیشتر از 6 کاراکتر باشد");
const description = Yup.string().max(
  2048,
  "توضیحات نمی تواند بیشتر از 2048 کاراکتر باشد"
);
const amount = Yup.string().required("مبلغ الزامی است");
const transactionType = Yup.string()
  .required("نوع تراکنش الزامی است")
  .oneOf(transactionTypeItems, "نوع تراکنش مجاز نیست");
const costType = Yup.string()
  .required("نوع هزینه الزامی است")
  .oneOf(costTypeItems, "نوع هزینه مجاز نیست");
const user = Yup.object({
  value: Yup.string().required("شناسه کاربر الزامی است"),
  label: Yup.string(),
}).required("کاربر الزامی است");
const title = Yup.string().required("عنوان الزامی است");
const price = Yup.string().required("قیمت الزامی است");
const basePrice = Yup.string().required("قیمت پایه الزامی است");
const vipPrice = Yup.string().required("قیمت ویژه الزامی است");
const totalTableAmount = Yup.string().required("قیمت نهایی میز الزامی است");
const count = Yup.string().required("تعداد الزامی است");
const isUnlimited = Yup.bool().required("وضعیت محصول الزامی است");
const percent = Yup.string().required("درصد چوب الزامی است");
const _id = Yup.string().required("شناسه الزامی است");
const cue = Yup.string().required("تعداد چوب الزامی است");
const deductWallet = Yup.string().required("مبلغ کسر از کیف پول الزامی است");
const isComplete = Yup.bool().required("وضعیت سفارش الزامی است");
const isSMS = Yup.bool().required("وضعیت ارسال پیامک الزامی است");
const birthDayAmount = Yup.string().required("مبلغ هدیه تولد الزامی است");
const dueDate = Yup.string().required("تاریخ سر رسید الزامی است");
const table = Yup.object({
  _id,
  cue,
  isVIP,
  price,
}).nullable();
const products = Yup.array(
  Yup.object({
    _id,
    title,
    price,
    count,
  }).required("محصول الزامی است")
);

// Login User
export const loginUserValidation = Yup.object({
  phoneNumber,
  password,
});

// Create User
export const createUserValidation = Yup.object({
  firstName,
  lastName,
  birthDate,
  phoneNumber,
  password,
  confirmPassword,
});

// Forgot Password
export const forgotPasswordValidation = Yup.object({
  phoneNumber,
});

// Edit User
export const editUserValidation = Yup.object({
  avatar: avatar.nullable(),
  firstName,
  lastName,
  phoneNumber,
  birthDate,
});

// Change Password
export const changePasswordValidation = Yup.object({
  password,
  newPassword,
  confirmPassword: Yup.string()
    .required("تکرار کلمه عبور جدید الزامی است")
    .oneOf(
      [Yup.ref("newPassword"), null],
      "کلمه عبور جدید و تکرار کلمه عبور جدید یکسان نیستند"
    ),
});

// Create User For Admin
export const createUserForAdminValidation = Yup.object().shape({
  avatar: avatar.nullable(),
  firstName,
  lastName,
  birthDate,
  phoneNumber,
  isVIP,
  permissions,
});

// Edit User For Admin
export const editUserForAdminValidation = Yup.object().shape({
  avatar: avatar.nullable(),
  firstName,
  lastName,
  birthDate,
  phoneNumber,
  isVIP,
  permissions,
});

// Change User Password
export const changeUserPasswordValidation = Yup.object().shape({
  password,
  confirmPassword,
});

// Create Transaction
export const createTransactionValidation = Yup.object().shape({
  isSMS,
  amount,
  description,
  type: transactionType,
});

// Create Product
export const createProductValidation = Yup.object().shape({
  title,
  price,
  basePrice,
  count,
  isUnlimited,
  description,
});

// Create Table
export const createTableValidation = Yup.object().shape({
  title,
  price,
  vipPrice,
  description,
});

// Edit Cue
export const editCueValidation = Yup.object().shape({
  count,
  percent,
});

// Edit Setting
export const editSettingValidation = Yup.object().shape({
  birthDayAmount,
});

// Create Order
export const createOrderValidation = Yup.object().shape({
  user,
  table,
  products,
  deductWallet,
  description,
});

// Create Product Order
export const createProductOrderValidation = Yup.object().shape({
  user,
  products: products.min(1, "انتخاب حداقل یک محصول الزامی است"),
  description,
  deductWallet,
});

// Edit Order
export const editOrderValidation = Yup.object().shape({
  user,
  table,
  products,
  deductWallet,
  description,
  totalTableAmount,
  isComplete,
});

// Create Cost
export const createCostValidation = Yup.object().shape({
  title,
  cost: price,
  type: costType,
  description,
});

// Create Debtor
export const createDebtorValidation = Yup.object().shape({
  user,
  amount,
  dueDate,
  description,
});
